import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Pencil, Trash2 } from 'lucide-react';

const ROLE_COLORS = {
  'Admin': 'bg-purple-100 text-purple-800 border-purple-200',
  'Sub Admin': 'bg-blue-100 text-blue-800 border-blue-200',
  'Agent': 'bg-green-100 text-green-800 border-green-200',
};

const UsersTable = ({ users, currentUser, onEdit, onDelete }) => {
  const canManageUser = (targetUser) => {
    if (currentUser.role === 'Admin') return true;
    if (currentUser.role === 'Sub Admin' && targetUser.role === 'Agent') return true;
    return false;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b">
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Name</th>
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Username</th>
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Role</th>
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Access Level</th>
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Status</th>
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Bank Edit</th>
            <th className="text-left p-3 text-sm font-semibold text-slate-600">Upload</th>
            <th className="text-right p-3 text-sm font-semibold text-slate-600">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-b hover:bg-slate-50">
              <td className="p-3 font-medium">{user.name}</td>
              <td className="p-3 text-slate-600">{user.username}</td>
              <td className="p-3"><Badge className={ROLE_COLORS[user.role] || 'bg-slate-100 text-slate-800'}>{user.role}</Badge></td>
              <td className="p-3">
                {user.accessLevel === 'all' ? (
                  <Badge variant="outline">All Access</Badge>
                ) : (
                  <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">Specific ({user.assignedBankIds?.length || 0} banks)</Badge>
                )}
              </td>
              <td className="p-3">
                {user.active ? (
                  <Badge className="bg-green-100 text-green-800 border-green-200">Active</Badge>
                ) : (
                  <Badge variant="outline" className="bg-slate-100 text-slate-600">Inactive</Badge>
                )}
              </td>
              <td className="p-3">
                {user.canEditBank !== false ? (
                  <Badge className="bg-blue-100 text-blue-800 border-blue-200">Allowed</Badge>
                ) : (
                  <Badge variant="outline" className="bg-red-50 text-red-600 border-red-200">Restricted</Badge>
                )}
              </td>
              <td className="p-3">
                {user.canUpload ? (
                  <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200">Yes</Badge>
                ) : (
                  <Badge variant="outline" className="bg-slate-50 text-slate-500">No</Badge>
                )}
              </td>
              <td className="p-3 text-right">
                {canManageUser(user) && (
                  <div className="flex justify-end gap-2">
                    <Button onClick={() => onEdit(user)} variant="outline" size="sm" className="gap-1"><Pencil className="w-3 h-3" />Edit</Button>
                    {user.id !== currentUser.id && (
                      <Button onClick={() => onDelete(user.id)} variant="outline" size="sm" className="gap-1 text-red-600 hover:text-red-700 hover:bg-red-50"><Trash2 className="w-3 h-3" />Delete</Button>
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsersTable;
